export default __webpack_public_path__ + "static/media/GDSC Logo.c2798d72.png";